import * as React from 'react';

import DocumentTitle from '../../misc/components/DocumentTitle';
import { useQueryTable, ClearFiltersAction } from "../../misc/components/queryTable/Hooks/UseQueryTable";

import { QueryOrderDirection } from "../../misc/api/apiTypes";

import { SubjectsTable } from './SubjectsTable';
import { Link } from 'react-router-dom';
import { Authorization } from '../../misc/components/Authorization';
import { useSecurityContext } from '../../Core/SecurityContext';
import { PermissionEnum } from '../../misc/api/ApiPermissionEnum';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';

export const SubjectsListScreen = (): JSX.Element => {  
    const { currentUserPermissions } = useSecurityContext();
    const { study, tableParameters } = useCurrentStudyConfigurationContext();


    const queryTableReducer = useQueryTable({
        query: {
            Order: {
                Member: "SubjectNumber",
                Direction: QueryOrderDirection.Ascending,
            },
            Page: {
                Current: 1,
                Length: tableParameters.DefaultPageSize,
            },
            Filters: []
        }
    });
    const [tableState, tableDispatch] = queryTableReducer;

    const clearAllFilters = () => {
        tableDispatch(ClearFiltersAction.create());
    };

    return (
        <DocumentTitle title="Subjects | Vitalograph Web Portal">
            <div className="row">
                <div className="col-md-6">
                    <h2 className="text-primary">Subjects</h2>
                </div>
                <div className="col-md-6">
                    <div className="h2 pull-right">
                        <Authorization studyId={study.id} currentPermissions={currentUserPermissions} permissionIdsAny={[PermissionEnum.CreateSubject, PermissionEnum.CreateSiteSubjects]}>
                            <Link id="createNew" className="btn btn-primary" to="/Subjects/Create">
                                Create New
                            </Link>&nbsp;
                        </Authorization>
                        <button id="clearAllFilters" className="btn btn-primary" onClick={clearAllFilters}>
                            Clear All Filters
                        </button>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="ibox">
                        <div className="ibox-content">
                            <div className="table-responsive">
                                <SubjectsTable queryTableReducer={queryTableReducer} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </DocumentTitle>
    );    
};

export default SubjectsListScreen;
